export const cleanData = (data) => {
    return Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value != null && (typeof value !== 'string' || value.trim() !== ""))
    );
};
